import type { InputHTMLAttributes } from 'react'
import { cn } from '@/shared/lib/cn'
import s from './Input.module.css'

type InputProps = InputHTMLAttributes<HTMLInputElement>

export function Input({ className, ...rest }: InputProps) {
  return <input className={cn(s.root, className)} {...rest} />
}
